import { Component, Prop, Vue } from 'vue-property-decorator';
import { Variants } from './enums';

@Component
export default class CalendarTextProps extends Vue {
  // Props
  @Prop({ type: String, default: Variants.NOTHING })
  variant: Variants;
}



// WEBPACK FOOTER //
// ./src/components/calendar/text/props.ts